import { useMemo } from 'react';
import { CourierPosition } from '../grpc/trafficUpdates_pb';

type LiveTrackingPolyline = {
  liveTrackingPolyline: GeoJSON.Feature<GeoJSON.Geometry>;
  lastKnownLiveTrackingPosition: {
    latitude: number;
    longitude: number;
  } | null;
};

const useLiveTrackingPolyline = (
  courierPositions: CourierPosition[],
): LiveTrackingPolyline => {
  const courierPosition = useMemo(
    () =>
      courierPositions?.map((x) => [x!.getLongitude(), x!.getLatitude()]) ?? [],
    [courierPositions],
  );

  const liveTrackingPolyline: GeoJSON.Feature<GeoJSON.Geometry> = {
    id: 'route',
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'LineString',
      coordinates: courierPosition,
    },
  };

  let lastKnownLiveTrackingPosition = null;
  if (courierPositions && courierPositions.length > 0) {
    lastKnownLiveTrackingPosition = {
      latitude: courierPosition[courierPosition.length - 1][1],
      longitude: courierPosition[courierPosition.length - 1][0],
    };
  }

  return { liveTrackingPolyline, lastKnownLiveTrackingPosition };
};

export default useLiveTrackingPolyline;
